exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".faq .head ol[data-v-f936cf28]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;padding-left:0;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.faq .head ol li[data-v-f936cf28]{margin-left:20px}.faq .head ol li .el-select[data-v-f936cf28]{width:100%}.faq .head ol li .el-date-editor[data-v-f936cf28]{width:100%}\n", ""]);

// exports
